import httpClient from '@/http-client'

export const get = (options = {}) => {
  return httpClient
    .get('/api/card-to-be-prints', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const previewPdf = data => {
  return httpClient
    .post('/api/card-to-be-prints/pdf-previews', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default { get, previewPdf }
